import { FlexRow } from '@/components/common/Flex';
import { chakra, FlexProps } from '@chakra-ui/react';
import { Button } from '../common/Button';
import ButtonWithIcon from '../common/ButtonWithIcon';
import { FlexCol } from '../common/Flex';
import { ArrowLeft, XClose } from '../common/icons';
import { Paragraph, Subheader } from '../common/Typography';

export interface TransactionCardLayoutProps extends FlexProps {
    title: string;
    subtitle?: string | JSX.Element;
    onNext: VoidFunction;
    onClose: VoidFunction;
    isNextDisabled?: boolean;
    isNextLoading?: boolean;
    nextButtonText?: string;
    onBack?: VoidFunction;
    backButtonText?: string;
    nextButtonTabIndex?: number;
}

const TransactionCardLayout = ({
    title,
    subtitle,
    onNext,
    onClose,
    isNextDisabled,
    isNextLoading,
    onBack,
    nextButtonText = 'Continue',
    backButtonText = 'Back',
    nextButtonTabIndex = 1,
    children,
    ...props
}: TransactionCardLayoutProps) => {
    return (
        <chakra.form
            onSubmit={(e) => {
                e.preventDefault();
                onNext();
            }}
            h={'full'}
        >
            <FlexCol
                h="full"
                px={8}
                pb={8}
                pt={12}
                position="relative"
                {...props}
            >
                <Button
                    position="absolute"
                    variant="ghost"
                    colorScheme="gray"
                    size="xs"
                    w={7}
                    minW={7}
                    h={7}
                    top={2}
                    right={2}
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                    }}
                    onClickEvent="Transaction Flow Close Button Clicked"
                    tabIndex={-1}
                >
                    <XClose size="sm" />
                </Button>

                <FlexCol grow={0} justifyContent="center">
                    <Subheader pr={2}>{title}</Subheader>
                    {subtitle && (
                        <Paragraph fontSize="sm" color="textMuted" mt={3}>
                            {subtitle}
                        </Paragraph>
                    )}
                </FlexCol>
                <FlexCol grow={1} my={4} overflowY="auto">
                    {children}
                </FlexCol>
                <FlexRow justify="space-between" align="center" grow={0}>
                    <div>
                        {onBack && (
                            <ButtonWithIcon
                                variant="ghost"
                                colorScheme="gray"
                                iconLeft={<ArrowLeft size="sm" />}
                                onClick={() => onBack()}
                                onClickEvent="Transaction Flow Back Button Clicked"
                                onClickEventParams={{ title }}
                                tabIndex={nextButtonTabIndex + 1}
                            >
                                {backButtonText}
                            </ButtonWithIcon>
                        )}
                    </div>
                    <Button
                        type="submit"
                        isDisabled={isNextDisabled}
                        isLoading={isNextLoading}
                        tabIndex={nextButtonTabIndex}
                        onClickEvent="Transaction Flow Submit Button Clicked"
                        onClickEventParams={{ title }}
                    >
                        {nextButtonText}
                    </Button>
                </FlexRow>
            </FlexCol>
        </chakra.form>
    );
};

export default TransactionCardLayout;
